
export default {
  list: [],
  quantidadeDePaginas: 0,
  exist: {
    email: false,
    cpf: false
  }
}



// WEBPACK FOOTER //
// ./src/features/admin/usuarios/store/state.js